import { CompareActionTypes, ProductGroupActionTypes, WishListActionTypes } from '../../../enums/ActionEnums';
import { updateWishListProducts, initializeWishListProducts } from '../../../redux/wishList/reducers/WishListReducer';
import { toggleComparedStateForItems } from '../../../redux/compare/reducers/CompareReducer';
import { setDeliveryPromiseToProducts } from '../../../util/ProductUtil';
import { normalizeProductGroupState } from '../../../util/ProductGroupUtil';
export const initialProductGroupState = {};
export const loadProductGroupReducer = (initialData = null) => {
    if (initialData === null || initialData === void 0 ? void 0 : initialData.productGroupId) {
        initialProductGroupState[initialData.productGroupId] = initialData.products;
    }
    return (state = initialProductGroupState, action) => {
        normalizeProductGroupState(state, initialProductGroupState);
        switch (action.type) {
            case CompareActionTypes.COMPARE_UPDATE_PRODUCTS:
                const newProductGroupItemsList = {};
                Object.keys(state).map(key => {
                    newProductGroupItemsList[key] = toggleComparedStateForItems(state[key], action.payload);
                });
                return Object.assign(Object.assign({}, state), newProductGroupItemsList);
            case WishListActionTypes.UPDATE_PRODUCTS:
                const newProductGroupItemsForUpdateWishList = {};
                Object.keys(state).map(key => {
                    newProductGroupItemsForUpdateWishList[key] = initializeWishListProducts(state[key], action);
                });
                return Object.assign(Object.assign({}, state), newProductGroupItemsForUpdateWishList);
            case WishListActionTypes.ADD_PRODUCT:
                const newProductGroupItemsForAddWishList = {};
                Object.keys(state).map(key => {
                    newProductGroupItemsForAddWishList[key] = updateWishListProducts(state[key], action, true);
                });
                return Object.assign(Object.assign({}, state), newProductGroupItemsForAddWishList);
            case WishListActionTypes.REMOVE_PRODUCT:
                const newProductGroupItemsForRemoveWishList = {};
                Object.keys(state).map(key => {
                    newProductGroupItemsForRemoveWishList[key] = updateWishListProducts(state[key], action, false);
                });
                return Object.assign(Object.assign({}, state), newProductGroupItemsForRemoveWishList);
            case ProductGroupActionTypes.SET_DELIVERY_PROMISE:
                return Object.assign(Object.assign({}, state), { [action.payload.productGroupId]: setDeliveryPromiseToProducts(state[action.payload.productGroupId], action.payload) });
            case ProductGroupActionTypes.SET_PRODUCT_GROUPS:
                return Object.assign(Object.assign({}, state), action.payload);
            default:
                return state;
        }
    };
};
export const productGroupReducer = loadProductGroupReducer();
